<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-29 13:48:09
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-18 18:38:35
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\newPatientmanage\components\UserDetails\minUserLeft.vue
-->
<template>
  <div class="basic-drawer" v-if="drawer">
    <el-radio-group v-model="tabPosition" class="top-radio-tab" style="margin:20px 0 28px">
      <el-radio-button label="first">决策树</el-radio-button>
      <el-radio-button label="second">消息推送计划</el-radio-button>
    </el-radio-group>
    <div class="aside" v-show="tabPosition == 'first'" style="height:calc(100% - 62px)">
      <el-scrollbar style="height: 100%;font-size: 12px;position: relative;">
        <Collapse v-if="userDetailsData && JSON.stringify(userDetailsData) !== '{}'" :logicList="userDetailsData"
          :modal="false">
        </Collapse>
        <div class="empty" v-else>
          <img src="@/views/treatment/static/empty.png" />
        </div>
      </el-scrollbar>
    </div>
    <div class="aside" v-if="tabPosition == 'second'" style="height:calc(100% - 82px)">
      <MsgSendPlan />
    </div>
  </div>
</template>

<script>
import Collapse from "@/views/treatment/components/RightContent/Collapse.vue"; // 折叠面板
import MsgSendPlan from "@/views/treatment/components/RightContent/MsgSendPlan.vue";

export default {
  name: "minLogic",
  props: {
    userDetailsData: {
      type: Object,
      default: () => {}
    },
    currentActive: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tabPosition: "first",
      drawer: false
    };
  },
  components: {
    Collapse,
    MsgSendPlan
  },
  created() {},
  watch: {
    currentActive(val) {
      if (val === "logic") {
        this.drawer = true;
      } else {
        this.drawer = false;
      }
    }
  },
  mounted() {
    if (this.currentActive === "logic") {
      this.drawer = true;
    } else {
      this.drawer = false;
    }
  },
  methods: {
    // 关闭抽屉式弹框
    handleClose() {
      // this.drawer = false
      this.$emit("closeDrawer", "");
    }
  },

  filters: {
    gestationalWeeksFilts(value) {
      if (value <= 12) {
        return ` ${value} ` + "[孕早期]";
      } else if (value <= 25) {
        return ` ${value} ` + "[孕中期]";
      } else {
        return ` ${value} ` + "[孕晚期]";
      }
    },
    bloodTypeFilt(value) {
      switch (value * 1) {
        case 1:
          return "A型";
        case 2:
          return "B型";
        case 3:
          return "AB型";
        case 4:
          return "O型";
        case 5:
          return "不清楚";
        default:
          return "";
      }
    },
    labourFilte(value) {
      switch (value * 1) {
        case 1:
          return "轻体力劳动";
        case 2:
          return "中等体力劳动";
        case 3:
          return "重体力劳动";
        case 4:
          return "极重体力劳动";
        default:
          return "";
      }
    },
    embryoNumberFilte(value) {
      switch (value * 1) {
        case 1:
          return "单胎";
        case 2:
          return "双胎";
        case 3:
          return "多胎";
        default:
          return "";
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "./index.less";
.empty {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.tab-plan-wrapper {
  display: flex;
  justify-content: space-between;
  /deep/.el-tabs {
    margin-right: 30px;
  }
  /deep/.el-tabs__header {
    margin: 0;
  }
}
.top-radio-tab {
  /deep/.el-radio-button__inner {
    padding: 0;
    width: 100px;
    height: 34px;
    line-height: 34px;
  }
}
.plan-detail-wrapper {
  margin-top: 30px;
  .plan-detail-time {
    span {
      display: inline-block;
      margin-right: 8px;
    }
    .yet-send {
      width: 38px;
      height: 15px;
      background: #dcebff;
      border-radius: 8px;
      font-size: 12px;
      font-weight: 600;
      color: #1a7bfc;
      text-align: center;
    }
    .no-send {
      width: 38px;
      height: 15px;
      background: #ffdcdc;
      border-radius: 8px;
      font-size: 12px;
      font-weight: 600;
      color: #d75858;
      text-align: center;
    }
    span:nth-child(1) {
      font-size: 14px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
    }
    .plan-name {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .plan-detail-card {
    background: #f8f8f8;
    border-radius: 6px;
    padding: 15px;
    // padding-bottom: 0;
    margin-top: 10px;
    .detail-row {
      display: flex;
      margin-bottom: 15px;
      div:nth-child(1) {
        margin-right: 20px;
        text-align: right;
        width: 72px;
      }
    }
    .detail-row:last-child {
      margin-bottom: 0;
    }
    div {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
</style>